import { render, staticRenderFns } from "./CpuUsage.vue?vue&type=template&id=3f67c48a"
import script from "./CpuUsage.vue?vue&type=script&lang=js"
export * from "./CpuUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports